import { LoginTheme } from ".";

const theme: LoginTheme = {
  title: "light",
  colors: {
    primary: "rgb(0, 41, 81)",
    secondary: "rgb(0,86,154)",
    tertiary: "rgb(236, 133, 0)",
    background: "white",
    scrollBar: "#e0e0e0",
    text: "black",
    navBarIcons: "rgb(0, 41, 81)",
    gray: "#545454",
    error: "#e74c3c",
    success: "#46c17d",
    warning: "#ffad00"
  },
  brand: {
    navy: "#003563",
    navyMed: "#2968A8",
    navyDeep: "#001A33",
    navyHover: "#00285a",
    green: "#99CC33",
    orange: "#CC6600",
    gold: "#FFB733",
    ink: "#1a2636",
    muted: "#6b7a8d",
    soft: "#8a9ab0",
    line: "#e3e8ef",
    bg: "#f0f2f5"
  }
};

export default theme;
